(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shaden-banner-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initEPBanner(banner) {
    var track = banner.querySelector('.shaden-epbanner__track');
    if (!track) return;

    var origCards = Array.from(
      track.querySelectorAll('.shaden-epbanner__card:not([data-clone])')
    );
    var count = origCards.length;
    if (count < 2) return;

    /* Clone first N cards so the loop feels seamless */
    var cloneN = Math.min(count, 3);
    for (var i = 0; i < cloneN; i++) {
      var cl = origCards[i % count].cloneNode(true);
      cl.setAttribute('data-clone', 'true');
      cl.setAttribute('aria-hidden', 'true');
      track.appendChild(cl);
    }

    var current  = 0;
    var speed    = (parseInt(banner.dataset.speed, 10) || 4) * 1000;
    var isRTL    = document.documentElement.dir === 'rtl';

    function cardOffset() {
      var card = track.querySelector('.shaden-epbanner__card');
      if (!card) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 12;
      return card.offsetWidth + gap;
    }

    function goTo(idx, animate) {
      var sign = isRTL ? 1 : -1;
      track.style.transition = animate
        ? 'transform 0.65s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';
      track.style.transform =
        'translateX(' + sign * idx * cardOffset() + 'px)';
    }

    function advance() {
      current++;
      goTo(current, true);
      /* When we land on a clone, snap back silently */
      if (current >= count) {
        setTimeout(function () {
          current = 0;
          goTo(0, false);
        }, 700);
      }
    }

    var timer = setInterval(advance, speed);

    /* Pause on hover */
    banner.addEventListener('mouseenter', function () {
      clearInterval(timer);
    });
    banner.addEventListener('mouseleave', function () {
      timer = setInterval(advance, speed);
    });

    /* Recalculate on resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(current, false); }, 100);
    });
  }

  function initAll() {
    document.querySelectorAll('.shaden-epbanner[data-speed]').forEach(initEPBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shaden-pdp"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   SHADEN PDP — interactions
   ============================================================ */
(function () {
  "use strict";

  /* ---- Gallery ---- */
  var _idx = {};

  function shpdpGoTo(idx, sid) {
    var track  = document.getElementById('shpdp-track-' + sid);
    var thumbs = document.querySelectorAll('#shpdp-thumbs-' + sid + ' .shpdp-gallery__thumb');
    var dots   = document.querySelectorAll('#shpdp-dots-' + sid + ' .shpdp-gallery__dot');
    if (!track) return;

    var count = thumbs.length || dots.length || 1;
    if (idx === 'prev') idx = ((_idx[sid] || 0) - 1 + count) % count;
    if (idx === 'next') idx = ((_idx[sid] || 0) + 1) % count;

    _idx[sid] = idx;
    /* RTL: positive translateX moves slides in reading direction */
    var dir = document.documentElement.getAttribute('dir') === 'rtl' ? 1 : -1;
    track.style.transform = 'translateX(' + (dir * idx * 100) + '%)';

    /* Match the stage aspect-ratio to the active slide's own image */
    var activeSlide = track.children[idx];
    var stage = document.getElementById('shpdp-stage-' + sid);
    if (stage && activeSlide && activeSlide.dataset.ar) {
      stage.style.setProperty('--shpdp-ar', activeSlide.dataset.ar);
    }

    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
  }
  window.shpdpGoTo = shpdpGoTo;

  /* Touch swipe on stage */
  document.querySelectorAll('.shpdp-gallery__stage').forEach(function (el) {
    var sid = el.closest('[id^="shpdp-"]').id.replace('shpdp-', '');
    var sx = 0;
    el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 15) {
        window._shadenSwipeLock = true;
        setTimeout(function() { window._shadenSwipeLock = false; }, 400);
      }
      if (Math.abs(dx) > 40) shpdpGoTo(dx > 0 ? 'prev' : 'next', sid);
    }, { passive: true });
  });

  /* ---- Variant selection ---- */
  window._shpdpVariants = window._shpdpVariants || {};

  function shpdpSelectOption(btn, sid) {
    var optIdx = parseInt(btn.dataset.optionIndex, 10);
    var value  = btn.dataset.value;

    /* Mark active pill in this option row */
    var row = btn.closest('.shpdp-pills');
    if (row) row.querySelectorAll('.shpdp-pill').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.value === value);
    });

    /* Update display label */
    var lbl = document.getElementById('shpdp-pick-' + sid + '-' + optIdx);
    if (lbl) lbl.textContent = value;

    /* Find matching variant */
    var allPills = document.querySelectorAll('#shpdp-form-' + sid + ' .shpdp-pills');
    var chosen = [];
    allPills.forEach(function (grp) {
      var active = grp.querySelector('.shpdp-pill.is-active');
      chosen.push(active ? active.dataset.value : null);
    });

    var variants = window['shadenVariants_' + sid] || [];
    var matched = variants.find(function (v) {
      return chosen.every(function (val, i) { return val === null || v['option' + (i + 1)] === val; });
    });

    if (matched) {
      if (typeof matched.image_index === 'number' && matched.image_index > -1) {
        shpdpGoTo(matched.image_index, sid);
      }

      var vidEl = document.getElementById('shpdp-vid-' + sid);
      if (vidEl) vidEl.value = matched.id;

      var nowEl = document.getElementById('shpdp-price-now-' + sid);
      if (nowEl) nowEl.textContent = matched.price_formatted;

      var wasEl = document.getElementById('shpdp-price-was-' + sid);
      if (wasEl) wasEl.textContent = matched.compare_at_price > 0 ? matched.compare_at_price_formatted : '';

      var stickyP = document.getElementById('shpdp-sticky-price-' + sid);
      if (stickyP) stickyP.textContent = matched.price_formatted;

      var atcBtn    = document.getElementById('shpdp-atc-' + sid);
      var lbl       = document.getElementById('shpdp-atc-label-' + sid);
      var stickyBtn = document.getElementById('shpdp-sticky-atc-' + sid);
      var buyNowBtn = document.getElementById('shpdp-buynow-' + sid);
      var isAr      = document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';

      if (!matched.available) {
        if (atcBtn) atcBtn.disabled = true;
        if (lbl) lbl.textContent = isAr ? 'نفد المخزون' : 'Out of Stock';
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = isAr ? 'نفد المخزون' : 'Out of Stock'; }
        if (buyNowBtn) buyNowBtn.disabled = true;
      } else {
        if (atcBtn) atcBtn.disabled = false;
        if (lbl) lbl.textContent = isAr ? 'أضيفي للسلة' : 'Add to Cart';
        if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = isAr ? 'أضيفي للسلة' : 'Add to Cart'; }
        if (buyNowBtn) buyNowBtn.disabled = false;
      }
    }
  }
  window.shpdpSelectOption = shpdpSelectOption;

  /* ---- Quantity ---- */
  function shpdpQty(delta, sid) {
    var input = document.getElementById('shpdp-qty-' + sid);
    if (!input) return;
    var val = parseInt(input.value) + delta;
    input.value = Math.max(1, Math.min(99, val));
  }
  window.shpdpQty = shpdpQty;

  /* ---- Toast ---- */
  var _toastT = {};
  function shpdpToast(msg, sid) {
    var toast = document.getElementById('shpdp-toast-' + sid);
    var span  = document.getElementById('shpdp-toast-msg-' + sid);
    if (!toast) return;
    if (msg && span) span.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(_toastT[sid]);
    _toastT[sid] = setTimeout(function () { toast.classList.remove('is-show'); }, 2400);
  }

  /* ---- Add to Cart ---- */
  function shpdpAddToCart(sid) {
    var vidEl  = document.getElementById('shpdp-vid-' + sid);
    var qtyEl  = document.getElementById('shpdp-qty-' + sid);
    var btn    = document.getElementById('shpdp-atc-' + sid);
    var sBtn   = document.getElementById('shpdp-sticky-atc-' + sid);
    if (!vidEl) return;
    if (btn && btn.disabled) return;

    var qty = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;
    [btn, sBtn].forEach(function (b) { if (b) { b.classList.add('loading'); b.disabled = true; } });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(vidEl.value), quantity: qty })
    })
    .then(function() { return fetch('/cart.js'); })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var isAr = document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';
      [btn, sBtn].forEach(function (b) {
        if (!b) return;
        b.classList.remove('loading');
        b.classList.add('added');
        setTimeout(function () { b.classList.remove('added'); b.disabled = false; }, 1400);
      });
      shpdpToast(isAr ? 'تمت الإضافة للسلة ✓' : 'Added to cart ✓', sid);
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, data: { itemCount: cart.item_count } }
      }));
    }).catch(function () {
      [btn, sBtn].forEach(function (b) { if (b) { b.classList.remove('loading'); b.disabled = false; } });
    });
  }
  window.shpdpAddToCart = shpdpAddToCart;

  /* ---- Buy Now ---- */
  function shpdpBuyNow(sid) {
    var vidEl = document.getElementById('shpdp-vid-' + sid);
    var qtyEl = document.getElementById('shpdp-qty-' + sid);
    if (!vidEl) return;
    var qty = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(vidEl.value), quantity: qty })
    }).then(function () { window.location = '/checkout'; })
      .catch(function ()  { window.location = '/checkout'; });
  }
  window.shpdpBuyNow = shpdpBuyNow;

  /* ---- Wishlist (localStorage) ---- */
  function shpdpToggleWish(sid) {
    var btn = document.getElementById('shpdp-wish-' + sid);
    var pdp = document.getElementById('shpdp-' + sid);
    var pid = pdp ? pdp.dataset.productId : null;
    if (!btn || !pid) return;

    var key  = 'shaden_wish';
    var list = JSON.parse(localStorage.getItem(key) || '[]');
    var idx  = list.indexOf(pid);
    var isAr = document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';

    if (idx > -1) {
      list.splice(idx, 1);
      btn.classList.remove('is-on');
      btn.querySelector('path').setAttribute('fill', 'none');
      shpdpToast(isAr ? 'أُزيل من المفضلة' : 'Removed from wishlist', sid);
    } else {
      list.push(pid);
      btn.classList.add('is-on');
      btn.querySelector('path').setAttribute('fill', 'currentColor');
      shpdpToast(isAr ? 'أُضيف إلى المفضلة' : 'Added to wishlist', sid);
    }
    localStorage.setItem(key, JSON.stringify(list));
  }
  window.shpdpToggleWish = shpdpToggleWish;

  /* Init wishlist state */
  document.querySelectorAll('[id^="shpdp-wish-"]').forEach(function (btn) {
    var sid = btn.id.replace('shpdp-wish-', '');
    var pdp = document.getElementById('shpdp-' + sid);
    var pid = pdp ? pdp.dataset.productId : null;
    if (!pid) return;
    var list = JSON.parse(localStorage.getItem('shaden_wish') || '[]');
    if (list.includes(pid)) {
      btn.classList.add('is-on');
      var path = btn.querySelector('path');
      if (path) path.setAttribute('fill', 'currentColor');
    }
  });

  /* ---- Accordions ---- */
  function shpdpAccToggle(btn) {
    btn.closest('.shpdp-acc__item').classList.toggle('is-open');
  }
  window.shpdpAccToggle = shpdpAccToggle;

  /* ---- Sticky bar (IntersectionObserver) ---- */
  document.querySelectorAll('[id^="shpdp-action-"]').forEach(function (actionRow) {
    var sid = actionRow.id.replace('shpdp-action-', '');
    var sticky = document.getElementById('shpdp-sticky-' + sid);
    if (!sticky) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.1 });
    io.observe(actionRow);
  });

})();

/* ================================================================
   REVIEWS — localStorage display + contact form notification
   ================================================================ */
(function () {
  "use strict";

  var starLabels = {
    ar: ['', 'مزعج', 'سيء', 'مقبول', 'جيد', 'ممتاز'],
    en: ['', 'Poor',  'Fair', 'Good',  'Very Good', 'Excellent']
  };

  var starSvgFull  = '<svg viewBox="0 0 24 24" fill="var(--sh-caramel)"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L4.5 9.7l5.9-.9L12 3.5z"/></svg>';
  var starSvgEmpty = '<svg viewBox="0 0 24 24" fill="var(--sh-line-strong)"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L4.5 9.7l5.9-.9L12 3.5z"/></svg>';

  /* ---- localStorage helpers ---- */
  function revKey(pid) { return 'shaden_revs_' + pid; }
  function getRevs(pid) { try { return JSON.parse(localStorage.getItem(revKey(pid)) || '[]'); } catch(e) { return []; } }
  function saveRev(pid, r) { var l = getRevs(pid); l.unshift(r); localStorage.setItem(revKey(pid), JSON.stringify(l)); }

  window.shpdpDelRev = function(sid, pid, idx) {
    var revs = getRevs(pid);
    revs.splice(idx, 1);
    localStorage.setItem(revKey(pid), JSON.stringify(revs));
    renderList(sid, pid);
  };

  /* ---- Render helpers ---- */
  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function starsRow(n) {
    var h = '';
    for (var i = 1; i <= 5; i++) h += (i <= n ? starSvgFull : starSvgEmpty);
    return h;
  }

  function fmtDate(iso, isAr) {
    try { return new Date(iso).toLocaleDateString(isAr ? 'ar-SA' : 'en-GB', {year:'numeric', month:'short', day:'numeric'}); }
    catch(e) { return ''; }
  }

  /* ---- Update inline rating (above product title) ---- */
  function updateInlineRating(sid, avg, count, isAr) {
    var starsEl = document.getElementById('shpdp-inline-stars-' + sid);
    var valEl   = document.getElementById('shpdp-rate-val-'    + sid);
    var cntEl   = document.getElementById('shpdp-rate-cnt-'    + sid);
    if (starsEl) starsEl.innerHTML  = starsRow(Math.round(avg));
    if (valEl)   valEl.textContent  = avg.toFixed(1);
    if (cntEl)   cntEl.textContent  = isAr ? count + ' تقييم' : count + ' reviews';
  }

  /* ---- Render review cards ---- */
  function renderList(sid, pid) {
    var isAr    = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
    var listEl  = document.getElementById('shpdp-rev-list-' + sid);
    var section = document.getElementById('shpdp-reviews-' + sid);
    var isAdmin = section && section.dataset.isAdmin === 'true';
    if (!listEl) return;

    var revs = getRevs(pid);

    if (revs.length) {
      var sum = revs.reduce(function(a, r) { return a + parseInt(r.rating); }, 0);
      updateInlineRating(sid, sum / revs.length, revs.length, isAr);

      listEl.innerHTML = revs.map(function(r, i) {
        var delBtn = isAdmin
          ? '<button class="shpdp-revcard__del" onclick="shpdpDelRev(\'' + sid + '\',\'' + pid + '\',' + i + ')" aria-label="حذف">'
            + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>'
            + '</button>'
          : '';
        return '<div class="shpdp-revcard" data-idx="' + i + '">'
          + '<div class="shpdp-revcard__top">'
          + '<div class="shpdp-revcard__mono">' + esc(r.name).charAt(0).toUpperCase() + '</div>'
          + '<div class="shpdp-revcard__meta"><b>' + esc(r.name) + '</b><small>' + fmtDate(r.date, isAr) + '</small></div>'
          + '<div class="shpdp-revcard__stars">' + '★'.repeat(r.rating) + '<span style="opacity:.3">' + '★'.repeat(5 - r.rating) + '</span></div>'
          + delBtn
          + '</div>'
          + '<p class="shpdp-revcard__body">' + esc(r.body) + '</p>'
          + '</div>';
      }).join('');
    } else {
      listEl.innerHTML = '<div class="shpdp-rev-list__empty">'
        + (isAr ? 'لا توجد تقييمات بعد — كوني أول من تقيّم!' : 'No reviews yet — be the first!')
        + '</div>';
    }
  }

  /* Init on page load */
  document.querySelectorAll('[id^="shpdp-reviews-"]').forEach(function(el) {
    var sid = el.id.replace('shpdp-reviews-', '');
    var pid = el.dataset.productId;
    if (pid) renderList(sid, pid);
  });

  /* ---- Open / close form ---- */
  window.shpdpOpenRevForm = function(sid) {
    var el = document.getElementById('shpdp-revform-' + sid);
    if (!el) return;
    el.removeAttribute('hidden');
    setTimeout(function() { el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 50);
  };

  window.shpdpCloseRevForm = function(sid) {
    var el = document.getElementById('shpdp-revform-' + sid);
    if (el) el.setAttribute('hidden', '');
  };

  /* ---- Star picker ---- */
  window.shpdpSetStar = function(val, sid) {
    var input = document.getElementById('shpdp-rev-rating-' + sid);
    var stars = document.querySelectorAll('#shpdp-rev-stars-' + sid + ' .shpdp-revform__star');
    var hint  = document.getElementById('shpdp-rev-hint-' + sid);
    var isAr  = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
    if (input) input.value = val;
    stars.forEach(function(s, i) { s.classList.toggle('is-active', i < val); });
    if (hint) { hint.style.color = ''; hint.textContent = (isAr ? starLabels.ar : starLabels.en)[val] || ''; }
  };

  document.querySelectorAll('[id^="shpdp-rev-stars-"]').forEach(function(wrap) {
    var stars = wrap.querySelectorAll('.shpdp-revform__star');
    stars.forEach(function(star, idx) {
      star.addEventListener('mouseenter', function() { stars.forEach(function(s,i){ s.classList.toggle('is-hover', i<=idx); }); });
      star.addEventListener('mouseleave', function() { stars.forEach(function(s){ s.classList.remove('is-hover'); }); });
    });
  });

  /* ---- Submit ---- */
  window.shpdpSubmitRev = function(e, sid) {
    e.preventDefault();
    var isAr   = document.documentElement.dir === 'rtl' || document.documentElement.lang === 'ar';
    var rating = document.getElementById('shpdp-rev-rating-' + sid);
    var hint   = document.getElementById('shpdp-rev-hint-'   + sid);
    var nameEl = document.getElementById('shpdp-rev-name-'   + sid);
    var emailEl= document.getElementById('shpdp-rev-email-'  + sid);
    var bodyEl = document.getElementById('shpdp-rev-body-'   + sid);
    var submit = document.getElementById('shpdp-rev-submit-' + sid);

    if (!rating || !rating.value) {
      if (hint) { hint.style.color = '#c0392b'; hint.textContent = isAr ? 'الرجاء اختيار عدد النجوم' : 'Please select a star rating'; }
      return;
    }

    var pid = document.getElementById('shpdp-reviews-' + sid).dataset.productId;
    var prod     = (document.querySelector('[name="review[product]"]')       || {}).value || '';
    var prodUrl  = (document.querySelector('[name="review[product_url]"]')   || {}).value || '';
    var prodImg  = (document.querySelector('[name="review[product_image]"]') || {}).value || '';

    /* 1 — Save to localStorage & render immediately */
    saveRev(pid, {
      name:      nameEl.value.trim(),
      rating:    parseInt(rating.value),
      body:      bodyEl.value.trim(),
      date:      new Date().toISOString(),
      product:   prod,
      productUrl: prodUrl,
      productImg: prodImg
    });
    renderList(sid, pid);

    /* 2 — Send contact email to admin */
    var fd = new FormData();
    fd.append('form_type', 'contact');
    fd.append('utf8', '✓');
    fd.append('contact[email]', emailEl ? emailEl.value : 'review@store.com');
    fd.append('contact[name]',  nameEl.value.trim());
    fd.append('contact[body]',
      '⭐ ' + rating.value + '/5\n📦 ' + prod + '\n\n' + bodyEl.value.trim()
    );
    fetch('/contact', { method: 'POST', body: fd });

    /* 3 — Reset & close */
    rating.value = ''; nameEl.value = ''; bodyEl.value = '';
    if (emailEl) emailEl.value = '';
    document.querySelectorAll('#shpdp-rev-stars-' + sid + ' .shpdp-revform__star').forEach(function(s){ s.classList.remove('is-active'); });
    if (hint) hint.textContent = isAr ? 'اختاري عدد النجوم' : 'Select a rating';
    document.getElementById('shpdp-revform-' + sid).setAttribute('hidden', '');
    shpdpToast(isAr ? 'تم نشر تقييمكِ ✓' : 'Review published ✓', sid);
  };

})();

/* ================================================================
   LIGHTBOX
   ================================================================ */
(function () {
  "use strict";

  var _lbIdx   = {};
  var _lbTotal = {};

  function lbTrack(sid) { return document.getElementById('shpdp-lb-track-' + sid); }
  function lbEl(sid)    { return document.getElementById('shpdp-lb-' + sid); }

  function lbSyncUI(sid) {
    var idx = _lbIdx[sid] || 0;
    var cur = document.getElementById('shpdp-lb-cur-' + sid);
    if (cur) cur.textContent = idx + 1;
    var dots = document.querySelectorAll('#shpdp-lb-dots-' + sid + ' .shpdp-lb__dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
  }

  function lbSlideTo(sid, idx) {
    _lbIdx[sid] = idx;
    var t = lbTrack(sid);
    if (t) t.style.transform = 'translateX(' + (idx * -100) + '%)';
    lbSyncUI(sid);
  }

  window.shpdpOpenLb = function (sid, idx) {
    if (window._shadenSwipeLock) return;
    _lbTotal[sid] = document.querySelectorAll('#shpdp-lb-track-' + sid + ' .shpdp-lb__slide').length;
    var t = lbTrack(sid);
    if (t) { t.style.transition = 'none'; t.style.transform = 'translateX(' + (idx * -100) + '%)'; }
    _lbIdx[sid] = idx;
    lbSyncUI(sid);
    requestAnimationFrame(function () {
      if (t) t.style.transition = 'transform .4s cubic-bezier(.22,1,.36,1)';
    });
    var el = lbEl(sid);
    if (el) { el.classList.add('is-open'); el.removeAttribute('aria-hidden'); document.body.style.overflow = 'hidden'; }
  };

  window.shpdpCloseLb = function (sid) {
    var el = lbEl(sid);
    if (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  };

  window.shpdpLbBgClick = function (e, sid) {
    if (e.target === e.currentTarget) shpdpCloseLb(sid);
  };

  window.shpdpLbNav = function (sid, dir) {
    var total = _lbTotal[sid] || document.querySelectorAll('#shpdp-lb-track-' + sid + ' .shpdp-lb__slide').length;
    lbSlideTo(sid, ((_lbIdx[sid] || 0) + dir + total) % total);
  };

  window.shpdpLbGoTo = function (sid, idx) {
    lbSlideTo(sid, idx);
  };

  /* Keyboard */
  document.addEventListener('keydown', function (e) {
    var open = document.querySelector('.shpdp-lb.is-open');
    if (!open) return;
    var sid = open.id.replace('shpdp-lb-', '');
    if (e.key === 'Escape')     shpdpCloseLb(sid);
    if (e.key === 'ArrowLeft')  shpdpLbNav(sid, -1);
    if (e.key === 'ArrowRight') shpdpLbNav(sid,  1);
  });

  /* Touch swipe inside lightbox */
  var _lbSx = null;
  document.addEventListener('touchstart', function (e) {
    var open = document.querySelector('.shpdp-lb.is-open');
    if (open && open.contains(e.target)) _lbSx = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (_lbSx === null) return;
    var open = document.querySelector('.shpdp-lb.is-open');
    if (!open) { _lbSx = null; return; }
    var dx = e.changedTouches[0].clientX - _lbSx;
    _lbSx = null;
    if (Math.abs(dx) < 40) return;
    shpdpLbNav(open.id.replace('shpdp-lb-', ''), dx < 0 ? 1 : -1);
  }, { passive: true });
})();


  } catch(e) { console.error(e); }
})();
})();
